export const APP_SETTINGS = {
  adobeAnalyticsEnabled: true,
};

export const TIER_DESCRIPTIONS = {
  ENTRY: 'ENTRY',
  CORE: 'CORE',
  PRO: 'PRO',
  ULTIMATE: 'ULTIMATE',
};

export const RVS_RULE_TYPE = {
  REWARD: 'Reward',
  FREE_TRIAL: 'FreeTrial',
  INSTANT_USER_PRODUCT: 'InstantUserProduct',
  FREESUB: 'FreeSub',
  LOYALTY_REWARD: 'LoyaltyReward',
  TRIAL: 'Trial',
  INSTANT_REWARD: 'InstantReward',
  FREE: 'Free',
};

// Statuses that make a subscription ineligible for cancellation. `nonrenew` is
// here because it is already ending, so there is nothing left to cancel — but it
// is still an active subscription, so it must NOT be used to hide cards.
export const INACTIVE_SUBSCRIPTION_STATUSES = ['nonrenew', 'cancelled', 'expired'];

// Statuses that keep a subscription out of the Subscriptions section entirely.
// The section lists what the user currently has; anything already ended belongs
// to Billing History. Deliberately excludes `nonrenew`, which still grants
// access until the period ends.
export const HIDDEN_SUBSCRIPTION_STATUSES = ['cancelled', 'expired'];

export const RVS_SUBSCRIPTION_TYPE = {
  NONE: 0,
  STANDARD: 1,
  TRIAL: 2,
  FREE: 3,
  PARTNER: 4,
};

export const VALID_PROCESSOR_PLAN_IDS = [
  'XUWZ4283',
  'FS-17',
  'FS-06',
  'FS-04',
  'FS-02',
  'FS-05',
  'IUYW8734',
];
